var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Card, Grid, Typography } from '@material-ui/core';
import { Auth0SignUpForm } from './Auth0SignUpForm';
import { EmailSignUpForm } from './EmailSignUpForm';
import { EmbeddedSignUpCardStyles, EmbeddedSignUpCardStylesIsLoggedOutHome, EmbeddedSignUpStyles, EmbeddedSignUpStylesIsLoggedOutHome, } from './EmbeddedSignUpTypes';
import { SocialSignUpForm } from './SocialSignUpForm';
var EmbeddedSignUpHeader = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.excludeTitle, excludeTitle = _b === void 0 ? false : _b, _c = _a.isReferral, isReferral = _c === void 0 ? false : _c, _d = _a.isLoggedOutHome, isLoggedOutHome = _d === void 0 ? false : _d;
    var classes = isLoggedOutHome ? EmbeddedSignUpStylesIsLoggedOutHome() : EmbeddedSignUpStyles();
    var intl = useIntl();
    var signupTitleDefault = intl.formatMessage({
        id: 'authentication.embedded-signup.header.title',
        defaultMessage: 'Explore your creativity with thousands of online classes',
        description: 'Message that shows up for sign up title.',
    });
    var signupSubtitleDefault = intl.formatMessage({
        id: 'authentication.embedded-signup.header.subtitle',
        defaultMessage: 'Start learning for free',
        description: 'Message that shows up for sign up subtitle.',
    });
    var signupTitle = title || signupTitleDefault;
    var signupSubtitle = subtitle || signupSubtitleDefault;
    var getHeader = function () {
        if (excludeTitle) {
            return (React.createElement(Typography, { component: "h3", variant: "h3", className: classes.subTitle }, signupSubtitle));
        }
        else if (isReferral) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { component: "h2", variant: "h1", className: classes.marketingAlt }, signupTitle),
                React.createElement(Typography, { component: "h3", variant: "body2", className: classes.subTitleAlt }, signupSubtitle)));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { component: "h2", variant: "h1", className: classes.marketing },
                    signupTitle,
                    React.createElement("span", { style: { color: '#00FF84' } }, ".")),
                React.createElement(Typography, { component: "h3", variant: "body2", className: classes.subTitle }, signupSubtitle)));
        }
    };
    return getHeader();
};
export function EmbeddedSignUp(props) {
    var intl = useIntl();
    var signUpCtaDefault = intl.formatMessage({
        id: 'authentication.embedded-signup.signup-cta.message',
        defaultMessage: 'Sign Up',
        description: 'Default message for sign up title.',
    });
    var redirectTo = props.redirectTo, _a = props.onlyEmail, onlyEmail = _a === void 0 ? false : _a, header = props.header, _b = props.config, config = _b === void 0 ? {} : _b, _c = props.signUpCta, signUpCta = _c === void 0 ? signUpCtaDefault : _c, _d = props.excludeTitle, excludeTitle = _d === void 0 ? false : _d, _e = props.isLoggedOutHome, isLoggedOutHome = _e === void 0 ? false : _e, _f = props.isReferral, isReferral = _f === void 0 ? false : _f, title = props.title, subtitle = props.subtitle, _g = props.showAuth0, showAuth0 = _g === void 0 ? false : _g, _h = props.showPopup, showPopup = _h === void 0 ? false : _h;
    var _j = __read(useState(onlyEmail), 2), isEmailFormOpen = _j[0], setIsEmailFormOpen = _j[1];
    var cardClasses = isLoggedOutHome
        ? EmbeddedSignUpCardStylesIsLoggedOutHome(props)
        : EmbeddedSignUpCardStyles(props);
    var classes = isLoggedOutHome ? EmbeddedSignUpStylesIsLoggedOutHome() : EmbeddedSignUpStyles();
    var cardClass = "embedded-signup-override " + cardClasses.root + " " + (config.isMUIResponsive ? cardClasses.cardMui : '');
    var formClass = classes.form + " " + (config.isMUIResponsive ? classes.formMui : '');
    var renderAuth0SignupForm = function () {
        return React.createElement(Auth0SignUpForm, { redirectTo: redirectTo, isModal: false, signUpCta: signUpCta, hideLogin: true, isLoggedOutHome: isLoggedOutHome });
    };
    var renderEmailSignUpForm = function () {
        return isEmailFormOpen ? (React.createElement(EmailSignUpForm, { redirectTo: redirectTo, isModal: false, signUpCta: signUpCta, hideLogin: true, isLoggedOutHome: isLoggedOutHome, showAuth0: showAuth0 })) : (React.createElement(SocialSignUpForm, { redirectTo: redirectTo, switchToEmailSignUp: setIsEmailFormOpen, excludeTitle: excludeTitle, hideLogin: true, isLoggedOutHome: isLoggedOutHome, showAuth0: showAuth0 }));
    };
    return (React.createElement(Grid, { container: true, className: classes.container },
        React.createElement(Card, { className: cardClass },
            React.createElement(Grid, { className: formClass },
                header ? (React.createElement(React.Fragment, null,
                    " ",
                    header,
                    " ")) : (React.createElement(EmbeddedSignUpHeader, { title: title, subtitle: subtitle, excludeTitle: excludeTitle, isReferral: isReferral, isLoggedOutHome: isLoggedOutHome })),
                React.createElement("div", { className: classes.formContainer }, showPopup ? renderAuth0SignupForm() : renderEmailSignUpForm()),
                config.bottomMobileIcon && React.createElement("div", { className: classes.iconContainer }, config.bottomMobileIcon)))));
}
//# sourceMappingURL=EmbeddedSignUp.js.map